import React from "react";
import { ListGroupItem } from "components/bootstrap";
const ControlledTableListItem = ({
  className = void 0,
  children
}) => /* @__PURE__ */ React.createElement(ListGroupItem, { className }, children);
export default ControlledTableListItem;
